export default {
  "pl": {
    "company": {
      "actions": {
        "changeCompany": "Zmień firmę",
        "searchCompany": "Wyszukaj firmę"
      },
      "attributes": {
        "address": "Adres",
        "email_address": "E-mail",
        "iban": "IBAN",
        "language": "Język",
        "name": "Nazwa firmy",
        "phone": "Numer telefonu",
        "subdomain": "Subdomena",
        "vat": "VAT"
      },
      "labels": {
        "company": "Firma",
        "contact": "Kontakt",
        "contacts": "Kontakty",
        "language": "To jest domyślny język firmy, który będzie wykorzystywany na stronie logowania oraz w przypadku klientów i członków zespołu.",
        "or": "LUB"
      },
      "validation": {
        "contactAlreadyExist": "Taki kontakt już istnieje. Wybierz go z listy rozwijanej.",
        "mustBeEmailAddress": "Należy podać poprawny adres e-mail",
        "needName": "Należy podać nazwę"
      }
    }
  }
}
